import { render, staticRenderFns } from "./InternalProjectOverviewRelation.vue?vue&type=template&id=69f4d3b6&"
import script from "./InternalProjectOverviewRelation.vue?vue&type=script&lang=js&"
export * from "./InternalProjectOverviewRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports